import Alpine from 'alpinejs';
import scrollTo from 'alpinejs-scroll-to';

Alpine.plugin(scrollTo);

window.Alpine = Alpine;

Alpine.start();
